import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { EngagementDiscountTierManager } from "@airdao/bond-periphery/core/contracts/types";
import { BigNumberish, AddressLike } from "ethers";

export type TierWithLevel = {
  level: BigNumberish;
  discount: BigNumberish;
}

export async function GetUserLevel(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, user: AddressLike): Promise<bigint> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.getUserLevel(user);
}

export async function GetUserTier(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, user: AddressLike): Promise<TierWithLevel> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  const result = await manager.getTier(user);
  return {
    level: result.level,
    discount: result.discount,
  };
}

export async function GetTierInfo(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, level: BigNumberish): Promise<TierWithLevel> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  const result = await manager.tier(level);
  return {
    level: result.level,
    discount: result.discount,
  };
}

export async function GetAllTiersInfo(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager): Promise<TierWithLevel[]> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  const result = await manager.tiers();
  return result.map(tier => ({
    level: tier.level,
    discount: tier.discount,
  }));
}

export async function GetContractDecimals(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.decimals();
}

export async function GetContractOracle(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager) {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.oracle();
}

export async function GetUserDiscount(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, user: AddressLike) : Promise<bigint> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.getDiscount(user);
}

export async function ApplyUserDiscount(contracts: Contracts, contractName: ContractNames = ContractNames.EngagementDiscountTierManager, user: AddressLike, amount: BigNumberish) : Promise<bigint> {
  const manager = contracts.getContractByName(contractName) as unknown as EngagementDiscountTierManager;
  return await manager.applyDiscount(amount, user);
}

export const GetterMethods = {
  GetUserLevel,
  GetUserTier,
  GetTierInfo,
  GetAllTiersInfo,
  GetContractDecimals,
  GetContractOracle,
  GetUserDiscount,
  ApplyUserDiscount,
};

export default GetterMethods;